import createVueComponent from '../createVueComponent';

const UserMinus2 = createVueComponent('UserMinus2Icon', [
  ['path', { d: 'M14 19a6 6 0 0 0-12 0', key: 'vej9p1' }],
  ['circle', { cx: '8', cy: '9', r: '4', key: '143rtg' }],
  ['line', { x1: '22', x2: '16', y1: '11', y2: '11', key: '1shjgl' }],
]);

export default UserMinus2;
